import React from "react";

export default ({ src, width, height }) => (
    <iframe src={src} width={width} height={height} scrolling="no" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen={true}></iframe>
);
